import React, { useEffect, useState, useContext } from "react";
import { Footer, Header, Loading } from "./";
import _ from "lodash";
import { Badge, Button, Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { api, constants } from "../utils";
import { default as useUserStore } from "../hooks/useUserStore";
import { ui_helpers } from "../helpers";
const PATHNAMES = constants.PATH_NAMES;

export default function ReportsIndex() {
  document.title = `Reports - ${constants.appName}`;
  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState([]);
  const currentUser = useUserStore(x => x.currentUser);
  useEffect(() => {
    setIsLoading(true);
    api.fetch('Resources/ReportGroups').then(res => {
      setReportData(res.data);
    }).catch((e) => console.error(e))
    .finally(() => setIsLoading(false));
  }, []);

  return (
    <div>
      <Header toolbar={ui_helpers.isSystemAdministrator(currentUser)} resources noComments>
        <Button color="light" tag={Link} to={PATHNAMES.RESOURCES_EDITREPORTDEF}>
          Edit Report Definitions
        </Button>
      </Header>
      {isLoading ? (
        <Loading />
      ) : (
        <Container fluid>
          <Row className="mt-4 px-5">
            {reportData && reportData.length ?
              _.map(reportData, (g) => (
                <Col key={g.dsc}>
                  <div className="report-header">{g.dsc}</div>
                  <hr className="mt-0" />
                  {g.reports && g.reports.length &&
                    _.map(g.reports, (r) => (
                      <div className="mt-1 mb-2" key={`rpt-${r.id}`}>
                        <Badge tag={Link} to={`/Report/${r.id}/Parameters`} color="dark" className="report-link" pill>
                          {r.dsc}
                        </Badge>
                        <div className="report-dsc">{r.dsc2}</div>
                      </div>
                    ))}
                </Col>
              )) : null}
          </Row>
        </Container>
      )}
      <Footer />
    </div>
  );
};
